export default {
  signUpSuccess: 'Succesfully registered! You\'ve been signed in as well.',
  signUpFailure: 'Registration failed. Email may be taken, or passwords don\'t match.',
  signInSuccess: 'Welcome!',
  signInFailure: 'Failed to sign in. Check your email and password and try again.',
  signOutSuccess: 'Come back soon!',
  changePasswordSuccess: 'Password changed successfully!',
  changePasswordFailure: 'Failed to change passwords. Check your old password and try again.',
  uploadImageSuccess: 'Image was successfully uploaded! Check your profile to see the new image!',
  uploadImageFailure: 'Could not upload the photo!',
  deleteImageSuccess: 'Deleted the image successfully',
  deleteImageFailure: 'Could not delete the photo!',
  updateImageSuccess: 'Succesfully updated the image!',
  updateImageFailure: 'Could not update the image!'
}



// WEBPACK FOOTER //
// ./src/components/AutoDismissAlert/messages.js